import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from '@routing/app.routing';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import EmpluPrimeTheme from '../scss/theme/prime.preset';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { provideEchartsCore } from 'ngx-echarts';
import { provideTranslateService } from '@ngx-translate/core';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { ConfirmationService, MessageService } from 'primeng/api';
import { tokenRefreshInterceptor } from '@core/interceptors/token-refresh.interceptor';
import { errorCatchingInterceptor } from '@core/interceptors/http-error.interceptor';
import { ngxTranslateConfig } from '@core/config/config.ngx-translate';

registerLocaleData(localeDe);
echarts.use([BarChart, LineChart, PieChart, GridComponent, TooltipComponent, CanvasRenderer]);

export function createPrimeNgProvider() {
    return providePrimeNG({
        theme: {
            preset: EmpluPrimeTheme,
            options: {
                darkModeSelector: 'html[data-theme="dark"]',
                cssLayer: { name: 'primeng', order: 'primeng' } // falls du Tailwind nutzt
            }
        }
    });
}

const interceptors: HttpInterceptorFn[] = [errorCatchingInterceptor, tokenRefreshInterceptor];

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withInterceptors([...interceptors])),
        provideBrowserGlobalErrorListeners(),
        provideAnimationsAsync(),
        provideEchartsCore({ echarts }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        createPrimeNgProvider(),
        provideAngularSvgIcon(),
        provideTranslateService(ngxTranslateConfig),
        MessageService,
        ConfirmationService,
        { provide: LOCALE_ID, useValue: 'de-DE' }
    ]
};
